import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "prototype-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("circle", { cx: 3.5, cy: 12.5, r: 2 }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", d: "m13.25 6.25 2-1.75-2-1.75z" }),
        React.createElement("path", { d: "M13.5 4.5h-1c-1.833 0-3 1.333-3.5 4s-1.667 4-3.5 4" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
